import { getEnv } from "../utils/env";

/*获取素材项目名称*/
export function getProjectName () {
  return '蝉妈妈·创意'
}

export function getCmmHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://sv-test.cds8.cn";
      break;

    case "test":
      host = "https://sv-test.cds8.cn";
      break;

    case "stage":
      host = "https://sv-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.chanmama.com";
      break;
  }
  return host;
}

export function getXhsHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://cmm-xhs-test.cds8.cn";
      break;

    case "test":
      host = "https://cmm-xhs-test.cds8.cn";
      break;

    case "stage":
      host = "https://cmm-xhs-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.chanxiaohong.com";
      break;
  }
  return host;
}

export function getCkHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://changkong-test.cds8.cn";
      break;

    case "test":
      host = "https://changkong-test.cds8.cn";
      break;

    case "stage":
      host = "https://changkong-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.changuanjia.com";
      break;
  }
  return host;
}

export function getCmfHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://cmm-brand-bi-test.cds8.cn";
      break;

    case "test":
      host = "https://cmm-brand-bi-test.cds8.cn";
      break;

    case "stage":
      host = "https://cmm-brand-bi-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.chanmofang.com";
      break;
  }
  return host;
}

export function getJxfHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://cmm-jingxuan-test.cds8.cn";
      break;

    case "test":
      host = "https://cmm-jingxuan-test.cds8.cn";
      break;

    case "stage":
      host = "https://cmm-jingxuan-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.chanxuan.com";
      break;
  }
  return host;
}

export function getCqqfHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://ck-medium-test.cds8.cn";
      break;

    case "test":
      host = "https://ck-medium-test.cds8.cn";
      break;

    case "stage":
      host = "https://ck-medium-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.kolkoc.com";
      break;
  }
  return host;
}

export function getCdsfHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://inc-cds-test.cds8.cn";
      break;

    case "test":
      host = "https://inc-cds-test.cds8.cn";
      break;

    case "stage":
      host = "https://inc-cds-stage.cds8.cn";
      break;

    case "prod":
      host = "https://www.chandashi.com";
      break;
  }
  return host;
}

export function getAppfHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://inc-cds-app-test.cds8.cn";
      break;

    case "test":
      host = "https://inc-cds-app-test.cds8.cn";
      break;

    case "stage":
      host = "https://inc-cds-app-stage.cds8.cn";
      break;

    case "prod":
      host = "https://app.chandashi.com";
      break;
  }
  return host;
}

export function getGameHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://inc-cds-game-test.cds8.cn/marketing";
      break;

    case "test":
      host = "https://inc-cds-game-test.cds8.cn/marketing";
      break;

    case "stage":
      host = "https://inc-cds-game-stage.cds8.cn/marketing";
      break;

    case "prod":
      host = "https://game.chandashi.com/marketing";
      break;
  }
  return host;
}

export function getMtlHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://cmm-chuangyi-test.cds8.cn";
      break;

    case "test":
      host = "https://cmm-chuangyi-test.cds8.cn";
      break;

    case "stage":
      host = "https://cmm-chuangyi-stage.cds8.cn";
      break;

    case "prod":
      host = "https://chuangyi.chanmama.com";
      break;
  }
  return host;
}

export function getCjHomeHref () {
  let host = "";
  switch (getEnv()) {
    case "dev":
      host = "https://cds-cy-test.cds8.cn";
      break;

    case "test":
      host = "https://cds-cy-test.cds8.cn";
      break;

    case "stage":
      host = "https://www.chanjing.cc";
      break;

    case "prod":
      host = "https://www.chanjing.cc";
      break;
  }
  return host;
}
